import React, { useState } from 'react';
import axios from 'axios';
import "./ChangePasswordForm.css";
import CustomInput from '../CustomInput/CustomInput';
import CustomBtn from '../CustomBtn/CustomBtn';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';

function ChangePasswordForm() {
  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);    

  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: ''
  });

  const [showPassword, setShowPassword] = useState({
    current_password: false,
    new_password: false,
    new_password_confirmation: false
  });
  const [loading, setLoading] = useState(false)
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.new_password !== formData.new_password_confirmation) {
      toast.error(currentLocal.home.notmatch, { position: "bottom-right", autoClose: 3000 });
      return;
    }
    setLoading(true)

    try {
      const response = await axios.post(`https://nanosoft.space/taarteb/public/api/user/change-password`, formData, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
        }
      });
      toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
      setLoading(false)

    } catch (error) {
      toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });
      setLoading(false)
      // alert("Failed to change password.");
    }
  };

  return (
    <div className='change_password_form_container'>
      <ToastContainer />
      <form className='form_container' onSubmit={handleSubmit}>
        <div className='position-relative'>
          <label>{currentLocal.home.Oldpassword}</label>
          <CustomInput
            type={showPassword.current_password ? "text" : "password"}
            name="current_password"
            value={formData.current_password}
            onChange={handleChange}
          />
          <button style={{ position: "absolute", top: "45%",
            
            right:currentLocal.language === "English"&&"10px",
            left:currentLocal.language === "العربيه"&&"10px",

            background: "#fff", border: 0 }} onClick={() => togglePasswordVisibility("current_password")}>
            {showPassword.current_password ?
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
              </svg>
              : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>}
          </button>
        </div>

        <div className='position-relative'>
          <label>{currentLocal.home.Newpassword}</label>
          <CustomInput
            type={showPassword.new_password ? "text" : "password"}
            name="new_password"
                        value={formData.new_password}
            onChange={handleChange}
          />
          <button type="button" style={{ position: "absolute", top: "45%", 
            right:currentLocal.language === "English"&&"10px",
            left:currentLocal.language === "العربيه"&&"10px",
             background: "#fff", border: 0 }} onClick={() => togglePasswordVisibility("new_password")}>
            {showPassword.new_password ?
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
              </svg>
              : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>}
          </button>
        </div>

        <div className='position-relative'>
          <label>{currentLocal.home.Confirmpassword}</label>
          <CustomInput
            type={showPassword.new_password_confirmation ? "text" : "password"}
            name="new_password_confirmation"
            value={formData.new_password_confirmation}
            onChange={handleChange}
          />
          <button type="button" style={{ position: "absolute", top: "45%", 
            
            right:currentLocal.language === "English"&&"10px",
            left:currentLocal.language === "العربيه"&&"10px",

            background: "#fff", border: 0 }} onClick={() => togglePasswordVisibility("new_password_confirmation")}>
            {showPassword.new_password_confirmation ?
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
              </svg>
              : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>}
          </button>
        </div>

        <div className='d-flex justify-content-center mt-4 '>
          <div className='w-75 d-flex justify-content-center'>
            <CustomBtn text={loading ?currentLocal.home.Loading : currentLocal.home.Save} disabled={loading} clickingFunction={handleSubmit} customWidth={"100%"} />

          </div>
        </div>
      </form>
    </div>
  );
}

export default ChangePasswordForm;
